// Mock data for ON THE WAY ride-hailing landing page
import {
  MapPin,
  Users,
  CreditCard,
  ShieldCheck,
  Share2,
  PhoneCall,
  Bike,
  Car,
  Navigation,
} from 'lucide-react';

export const NAV_LINKS = [
  { label: 'How it works', href: '#how-it-works' },
  { label: 'Fares', href: '#fares' },
  { label: 'Cities', href: '#cities' },
  { label: 'Drive with us', href: '#drive' },
  { label: 'Safety', href: '#safety' },
  { label: 'FAQs', href: '#faqs' },
];

export const HERO_STATS = [
  { value: '12', label: 'INDIAN CITIES' },
  { value: '0%', label: 'SURGE IN OFF-HOURS' },
  { value: '24/7', label: 'IN-APP SUPPORT' },
];

export const STEPS = [
  {
    n: '01',
    icon: MapPin,
    title: 'Set your destination',
    desc: 'Pick from saved places or search any address across India.',
  },
  {
    n: '02',
    icon: Users,
    title: 'Match with a driver',
    desc: 'Real-time dispatch finds you the closest verified driver.',
  },
  {
    n: '03',
    icon: CreditCard,
    title: 'Pay your way',
    desc: 'Cash, UPI, or in-app wallet. No hidden charges, ever.',
  },
];

export const CITIES = [
  { name: 'Bangalore', tag: 'HQ · Karnataka' },
  { name: 'Mumbai', tag: 'Maharashtra' },
  { name: 'Delhi NCR', tag: 'NCT' },
  { name: 'Hyderabad', tag: 'Telangana' },
  { name: 'Chennai', tag: 'Tamil Nadu' },
  { name: 'Kolkata', tag: 'West Bengal' },
  { name: 'Pune', tag: 'Maharashtra' },
  { name: 'Ahmedabad', tag: 'Gujarat' },
  { name: 'Jaipur', tag: 'Rajasthan' },
  { name: 'Lucknow', tag: 'Uttar Pradesh' },
  { name: 'Chandigarh', tag: 'Punjab / Haryana' },
  { name: 'Kochi', tag: 'Kerala' },
];

export const FACES = [
  {
    tag: 'BIKE TAXI',
    title: 'Quick pickups, zero traffic',
    desc: '\u20B919 minimum fares, 2-minute pickup in peak hours.',
    accent: 'Bike',
    icon: Bike,
    img: 'https://images.pexels.com/photos/35671476/pexels-photo-35671476.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    tag: 'CABS WAITING',
    title: 'A car for every trip',
    desc: 'Mini, Sedan, SUV \u2014 clean cars, polite drivers, transparent fares.',
    accent: 'Cab',
    icon: Car,
    img: 'https://images.pexels.com/photos/10921166/pexels-photo-10921166.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    tag: 'AUTO RICKSHAW',
    title: 'Local, fast, friendly',
    desc: 'Verified auto drivers across 12 cities. Daily UPI payouts.',
    accent: 'Auto',
    icon: Navigation,
    img: 'https://images.pexels.com/photos/67183/pexels-photo-67183.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
];

export const SAFETY = [
  {
    icon: ShieldCheck,
    title: 'Verified drivers',
    desc: 'License, RC, and background check before they hit the road.',
  },
  {
    icon: Share2,
    title: 'Share trip live',
    desc: 'One tap to share your live location with family or friends.',
  },
  {
    icon: PhoneCall,
    title: 'SOS & masked calls',
    desc: 'In-app emergency support and number masking on every chat.',
  },
];

export const DRIVER_BENEFITS = [
  'Weekly performance rewards',
  'Zero registration fee',
];

export const DRIVE_CITIES = [
  'Bangalore', 'Mumbai', 'Delhi NCR', 'Hyderabad', 'Chennai', 'Kolkata', 'Pune', 'Ahmedabad',
];

export const VEHICLES = ['Bike', 'Auto', 'Mini / Sedan', 'SUV'];

export const CONTACT = {
  addressLines: [
    'No 1, 2, 3 Samruddi Nilaya,',
    'Jodi Bhavi Road, Rukmini Nagar,',
    'Nagasandra, Bangalore \u2014 560 073',
  ],
  phone: '+91 86181 96685',
  email: 'support@onthe-way.in',
  gstin: '29DVTPK8685J1ZA',
};

// Saved places + driver profiles used in the Book-a-ride flow
export const SAVED_PLACES = [
  { name: 'Home', address: 'Indiranagar, Bangalore' },
  { name: 'Work', address: 'Manyata Tech Park, Bangalore' },
  { name: 'KSR Bengaluru Railway Station', address: 'Gubbi Thotadappa Rd' },
  { name: 'Kempegowda Intl. Airport', address: 'Devanahalli' },
  { name: 'Phoenix Marketcity', address: 'Whitefield' },
  { name: 'UB City Mall', address: 'Vittal Mallya Rd' },
];

export const RIDE_TYPES = [
  { id: 'bike',  label: 'Bike',     eta: '2 min',  price: 49,  seats: '1 seat',  icon: Bike },
  { id: 'auto',  label: 'Auto',     eta: '4 min',  price: 89,  seats: '3 seats', icon: Navigation },
  { id: 'mini',  label: 'OTW Mini', eta: '5 min',  price: 149, seats: '4 seats', icon: Car },
  { id: 'sedan', label: 'Sedan',    eta: '6 min',  price: 186, seats: '4 seats', icon: Car },
  { id: 'suv',   label: 'SUV',      eta: '8 min',  price: 239, seats: '6 seats', icon: Car },
];

export const DRIVERS = [
  { name: 'Ravi K.',    car: 'Honda City',    plate: 'KA 05 MF 1842', rating: 4.9 },
  { name: 'Anil S.',    car: 'Maruti Swift',  plate: 'KA 03 AB 9821', rating: 4.8 },
  { name: 'Manoj P.',   car: 'Hyundai Aura',  plate: 'KA 51 CD 4490', rating: 4.9 },
  { name: 'Suresh M.',  car: 'TVS Apache',    plate: 'KA 19 EF 6705', rating: 4.7 },
];
